// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Ord = require("ord");
var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ListUtils$SmartcutsMacros = require("../../../bs-utils/src/ListUtils.bs.js");
var DOM__Search$SmartcutsMacros = require("../devProtocol/DOM__Search.bs.js");
var DOM__Shadow$SmartcutsMacros = require("../DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var TextContents$SmartcutsMacros = require("../TextContents.bs.js");
var SelectionSemantics__Shared$SmartcutsMacros = require("./SelectionSemantics__Shared.bs.js");
var ContentScriptPlayback__Click$SmartcutsMacros = require("../commands/shared/ContentScriptPlayback__Click.bs.js");
var Selection__ContentEditableCursor$SmartcutsMacros = require("../Selection/Selection__ContentEditableCursor.bs.js");
var SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros = require("./SelectionSemantics__ContentEditableCursorSemantics__Types.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* CursorAtStartOfContentEditable */0) {
      return ["CursorAtStartOfContentEditable"];
    } else {
      return ["CursorAtEndOfContentEditable"];
    }
  }
  switch (v.TAG | 0) {
    case /* CursorAtStartOfNthParagraph */0 :
        return [
                "CursorAtStartOfNthParagraph",
                Decco.intToJson(v._0)
              ];
    case /* CursorAtEndOfNthParagraph */1 :
        return [
                "CursorAtEndOfNthParagraph",
                Decco.intToJson(v._0)
              ];
    case /* CursorAfterWordAtIndexInNthParagraph */2 :
        return [
                "CursorAfterWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
              ];
    case /* CursorBeforeWordAtIndexInNthParagraph */3 :
        return [
                "CursorBeforeWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
              ];
    case /* CursorInsideWordAtIndexInNthParagraph */4 :
        return [
                "CursorInsideWordAtIndexInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_encode(v._0)
              ];
    case /* CursorInsideWordInNthParagraph */5 :
        return [
                "CursorInsideWordInNthParagraph",
                SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWord_encode(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CursorAfterWordAtIndexInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorAfterWordAtIndexInNthParagraph */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CursorAtEndOfContentEditable" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CursorAtEndOfContentEditable */1
                  };
          }
      case "CursorAtEndOfNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorAtEndOfNthParagraph */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "CursorAtStartOfContentEditable" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CursorAtStartOfContentEditable */0
                  };
          }
      case "CursorAtStartOfNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorAtStartOfNthParagraph */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "CursorBeforeWordAtIndexInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorBeforeWordAtIndexInNthParagraph */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "CursorInsideWordAtIndexInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorInsideWordAtIndexInNthParagraph */4,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "CursorInsideWordInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = SelectionSemantics__ContentEditableCursorSemantics__Types$SmartcutsMacros.paragraphWord_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorInsideWordInNthParagraph */5,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function contentsInsideNthParagraph(nthParagraph, textContents) {
  var arg = Belt_List.get(Belt_List.reverse(Belt_List.reduce(textContents, /* [] */0, (function (paragraphs, textContent) {
                  if (textContent.TAG === /* TextSegment */0) {
                    var element = textContent._0;
                    if (element.TAG === /* NonEmptySegment */0) {
                      var match = element._0;
                      var text = match.text;
                      var index = match.textNodeIndex;
                      var parentElement = match.parentElement;
                      if (paragraphs) {
                        return Belt_List.add(paragraphs.tl, Belt_List.add(paragraphs.hd, [
                                        parentElement,
                                        index,
                                        text
                                      ]));
                      } else {
                        return {
                                hd: {
                                  hd: [
                                    parentElement,
                                    index,
                                    text
                                  ],
                                  tl: /* [] */0
                                },
                                tl: /* [] */0
                              };
                      }
                    }
                    var element$1 = element._0;
                    var text$1 = "";
                    if (paragraphs) {
                      return Belt_List.add(paragraphs.tl, Belt_List.add(paragraphs.hd, [
                                      element$1,
                                      -1,
                                      text$1
                                    ]));
                    } else {
                      return {
                              hd: {
                                hd: [
                                  element$1,
                                  -1,
                                  text$1
                                ],
                                tl: /* [] */0
                              },
                              tl: /* [] */0
                            };
                    }
                  }
                  var element$2 = textContent._0;
                  if (element$2.TAG !== /* NonEmptySegment */0) {
                    return Belt_List.add(paragraphs, {
                                hd: [
                                  element$2._0,
                                  -1,
                                  ""
                                ],
                                tl: /* [] */0
                              });
                  }
                  var match$1 = element$2._0;
                  return Belt_List.add(paragraphs, {
                              hd: [
                                match$1.parentElement,
                                0,
                                match$1.text
                              ],
                              tl: /* [] */0
                            });
                }))), nthParagraph);
  return Belt_List.reverse((function (param) {
                  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                })(/* [] */0));
}

function locateWordAtIndexInTexts(wordIndex, texts) {
  var func = function (param, param$1) {
    return ListUtils$SmartcutsMacros.shortcutWithState(wordIndex, param, param$1);
  };
  var arg = Curry._2(func, (function (remainingWords, param) {
          var words = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, param[2]);
          if (words.length > remainingWords) {
            return [
                    0,
                    [
                      param[0],
                      param[1],
                      Caml_array.get(words, remainingWords)
                    ]
                  ];
          } else {
            return [
                    remainingWords - words.length | 0,
                    undefined
                  ];
          }
        }), texts);
  var param = "Expected to locateWordAtIndexInTexts()";
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function moveCursorToNodeAndOffset(node, offset) {
  var domRange = document.createRange();
  domRange.setStart(node, offset);
  domRange.setEnd(node, offset);
  var maybeSelection = window.getSelection();
  if (!(maybeSelection == null)) {
    if (maybeSelection.rangeCount > 0) {
      maybeSelection.removeAllRanges();
    }
    maybeSelection.addRange(domRange);
  }
  return Promise.resolve({
              TAG: /* Ok */0,
              _0: undefined
            });
}

function moveCursorInsideContentEditable(contentEditableHost, semantic) {
  var textContents = TextContents$SmartcutsMacros.ForPlayback.fromElement(contentEditableHost);
  if (typeof semantic === "number") {
    if (semantic === /* CursorAtStartOfContentEditable */0) {
      var match = Belt_List.get(textContents, 0);
      if (match === undefined) {
        return Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  });
      }
      var nodeAndOffset = TextContents$SmartcutsMacros.TextSegment.toMaybeRangeContainerAndOffsetForCursor(/* Start */0, match._0);
      var node = nodeAndOffset[0];
      if (node !== undefined) {
        return moveCursorToNodeAndOffset(Caml_option.valFromOption(node), nodeAndOffset[1]);
      } else {
        return Promise.resolve({
                    TAG: /* Ok */0,
                    _0: undefined
                  });
      }
    }
    var match$1 = ListUtils$SmartcutsMacros.last(textContents);
    if (match$1 === undefined) {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                });
    }
    var nodeAndOffset$1 = TextContents$SmartcutsMacros.TextSegment.toMaybeRangeContainerAndOffsetForCursor(/* End */1, match$1._0);
    var node$1 = nodeAndOffset$1[0];
    if (node$1 !== undefined) {
      return moveCursorToNodeAndOffset(Caml_option.valFromOption(node$1), nodeAndOffset$1[1]);
    } else {
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                });
    }
  } else {
    switch (semantic.TAG | 0) {
      case /* CursorAtStartOfNthParagraph */0 :
          var nthParagraph = semantic._0;
          var match$2 = contentsInsideNthParagraph(nthParagraph, textContents);
          if (!match$2) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthParagraph */0,
                          _0: nthParagraph
                        }
                      });
          }
          var match$3 = match$2.hd;
          var maybeNode = match$3[0].childNodes.item(match$3[1]);
          if (maybeNode == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          } else {
            return moveCursorToNodeAndOffset(maybeNode, 0);
          }
      case /* CursorAtEndOfNthParagraph */1 :
          var nthParagraph$1 = semantic._0;
          var match$4 = ListUtils$SmartcutsMacros.last(contentsInsideNthParagraph(nthParagraph$1, textContents));
          if (match$4 === undefined) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthParagraph */0,
                          _0: nthParagraph$1
                        }
                      });
          }
          var maybeNode$1 = match$4[0].childNodes.item(match$4[1]);
          if (maybeNode$1 == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          }
          var offset = match$4[2].length;
          return moveCursorToNodeAndOffset(maybeNode$1, offset);
      case /* CursorAfterWordAtIndexInNthParagraph */2 :
          var match$5 = semantic._0;
          var match$6 = locateWordAtIndexInTexts(match$5.wordIndex, contentsInsideNthParagraph(match$5.nthParagraph, textContents));
          var match$7 = match$6[2];
          var wordEnds = match$7[0] + match$7[1].length | 0;
          var maybeNode$2 = match$6[0].childNodes.item(match$6[1]);
          if (maybeNode$2 == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          } else {
            return moveCursorToNodeAndOffset(maybeNode$2, match$5.offset + wordEnds | 0);
          }
      case /* CursorBeforeWordAtIndexInNthParagraph */3 :
          var match$8 = semantic._0;
          var match$9 = locateWordAtIndexInTexts(match$8.wordIndex, contentsInsideNthParagraph(match$8.nthParagraph, textContents));
          var maybeNode$3 = match$9[0].childNodes.item(match$9[1]);
          if (maybeNode$3 == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          } else {
            return moveCursorToNodeAndOffset(maybeNode$3, match$9[2][0] - match$8.offset | 0);
          }
      case /* CursorInsideWordAtIndexInNthParagraph */4 :
          var match$10 = semantic._0;
          var match$11 = locateWordAtIndexInTexts(match$10.wordIndex, contentsInsideNthParagraph(match$10.nthParagraph, textContents));
          var maybeNode$4 = match$11[0].childNodes.item(match$11[1]);
          if (maybeNode$4 == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          } else {
            return moveCursorToNodeAndOffset(maybeNode$4, match$10.offset + match$11[2][0] | 0);
          }
      case /* CursorInsideWordInNthParagraph */5 :
          var match$12 = semantic._0;
          var match$13 = locateWordAtIndexInTexts(match$12.wordIndex, contentsInsideNthParagraph(match$12.nthParagraph, textContents));
          var match$14 = match$13[2];
          var maybeNode$5 = match$13[0].childNodes.item(match$13[1]);
          if (maybeNode$5 == null) {
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          }
          var offset$1 = (match$14[1].length >> 1);
          return moveCursorToNodeAndOffset(maybeNode$5, match$14[0] + offset$1 | 0);
      
    }
  }
}

function moveCursorInsideContentEditableLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function (result_contentEditableHost) {
              if (result_contentEditableHost.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_contentEditableHost._0
                          });
              }
              var contentEditableHost = result_contentEditableHost._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(contentEditableHost, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG !== /* Ok */0) {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                          var activeElement = DOM__Shadow$SmartcutsMacros.getActiveElementForDocument(undefined);
                          var tmp;
                          if (activeElement !== undefined) {
                            if (Caml_option.valFromOption(activeElement) === contentEditableHost) {
                              tmp = Promise.resolve(undefined);
                            } else {
                              var match = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(contentEditableHost);
                              tmp = ContentScriptPlayback__Click$SmartcutsMacros.click(match[0], match[1], contentEditableHost);
                            }
                          } else {
                            var match$1 = DOM__Element$SmartcutsMacros.getClientXAndClientYOfCenterOfElement(contentEditableHost);
                            tmp = ContentScriptPlayback__Click$SmartcutsMacros.click(match$1[0], match$1[1], contentEditableHost);
                          }
                          return tmp.then(function (param) {
                                        return moveCursorInsideContentEditable(contentEditableHost, semantic);
                                      }).then(function (result) {
                                      if (result.TAG === /* Ok */0) {
                                        return Promise.resolve({
                                                    TAG: /* Ok */0,
                                                    _0: undefined
                                                  });
                                      } else {
                                        return Promise.resolve({
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      TAG: /* ContentEditableCursorSemanticError */3,
                                                      _0: result._0
                                                    }
                                                  });
                                      }
                                    });
                        });
            });
}

function toHumanReadable(semantic) {
  if (typeof semantic === "number") {
    if (semantic === /* CursorAtStartOfContentEditable */0) {
      return "to the start of the editor";
    } else {
      return "to the end of the editor";
    }
  }
  switch (semantic.TAG | 0) {
    case /* CursorAtStartOfNthParagraph */0 :
        return "to the start of the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
    case /* CursorAtEndOfNthParagraph */1 :
        return "to the end of the " + (StringUtils$SmartcutsMacros.withOrd(semantic._0 + 1 | 0) + " paragraph");
    case /* CursorAfterWordAtIndexInNthParagraph */2 :
        var match = semantic._0;
        return "after the " + (StringUtils$SmartcutsMacros.withOrd(match.wordIndex + 1 | 0) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match.nthParagraph + 1 | 0) + " paragraph")));
    case /* CursorBeforeWordAtIndexInNthParagraph */3 :
        var match$1 = semantic._0;
        var offset = match$1.offset;
        return "to the " + ((
                  offset === 0 ? "beginning of the " : Ord(offset + 1 | 0) + " character of the "
                ) + (StringUtils$SmartcutsMacros.withOrd(match$1.wordIndex + 1 | 0) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$1.nthParagraph + 1 | 0) + " paragraph"))));
    case /* CursorInsideWordAtIndexInNthParagraph */4 :
        var match$2 = semantic._0;
        var nthChar = match$2.offset + 1 | 0;
        var nthWord = match$2.wordIndex + 1 | 0;
        return "before the " + (StringUtils$SmartcutsMacros.withOrd(nthChar) + (" character of the " + (StringUtils$SmartcutsMacros.withOrd(nthWord) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$2.nthParagraph + 1 | 0) + " paragraph")))));
    case /* CursorInsideWordInNthParagraph */5 :
        var match$3 = semantic._0;
        var nthWord$1 = match$3.wordIndex + 1 | 0;
        return "anywhere inside the " + (StringUtils$SmartcutsMacros.withOrd(nthWord$1) + (" word of the " + (StringUtils$SmartcutsMacros.withOrd(match$3.nthParagraph + 1 | 0) + " paragraph")));
    
  }
}

var Semantic = {
  t_encode: t_encode,
  t_decode: t_decode,
  contentsInsideNthParagraph: contentsInsideNthParagraph,
  locateWordAtIndexInTexts: locateWordAtIndexInTexts,
  moveCursorToNodeAndOffset: moveCursorToNodeAndOffset,
  moveCursorInsideContentEditable: moveCursorInsideContentEditable,
  moveCursorInsideContentEditableLocatedAtSelector: moveCursorInsideContentEditableLocatedAtSelector,
  toHumanReadable: toHumanReadable
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function ofContentEditableCursor(cursor) {
  var textContents = cursor.textContents;
  if (Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isCursorAtStartOfContentEditable(cursor)) {
    return [/* CursorAtStartOfContentEditable */0];
  }
  if (Selection__ContentEditableCursor$SmartcutsMacros.ForRecordingAndAuthoring.isCursorAtEndOfContentEditable(cursor)) {
    return [/* CursorAtEndOfContentEditable */1];
  }
  var func = TextContents$SmartcutsMacros.ForRecordingAndAuthoring.search;
  var func$1 = Curry._1(func, cursor.domElementRepresentation.domElementIdentifier);
  var maybeResult = Curry._2(func$1, cursor.textNodeIndex, textContents);
  if (maybeResult === undefined) {
    return [];
  }
  var index = maybeResult.index;
  var nthParagraph = maybeResult.nthParagraph;
  var contentsAfterTextNode = ListUtils$SmartcutsMacros.drop(index + 1 | 0, textContents);
  var contentsInParagraphUntilTextNode = $$Array.of_list(ListUtils$SmartcutsMacros.drop(maybeResult.currentParagraphStartsAtIndex, ListUtils$SmartcutsMacros.take(index, textContents)));
  var contentsInParagraphAfterTextNode = ListUtils$SmartcutsMacros.takeWhile((function (textContent) {
          if (textContent.TAG === /* TextSegment */0) {
            return true;
          } else {
            return false;
          }
        }), contentsAfterTextNode);
  var offsetSinceParagraphStarts = Belt_Array.reduce(contentsInParagraphUntilTextNode, cursor.offset, (function (acc, content) {
          return acc + TextContents$SmartcutsMacros.textGet(content).length | 0;
        }));
  if (offsetSinceParagraphStarts === 0) {
    return [{
              TAG: /* CursorAtStartOfNthParagraph */0,
              _0: nthParagraph
            }];
  }
  if (index === List.length(textContents) && contentsInParagraphAfterTextNode === /* [] */0) {
    return [{
              TAG: /* CursorAtEndOfNthParagraph */1,
              _0: nthParagraph
            }];
  }
  var textInParagraphUpToAndIncludingTextNode = $$Array.map(TextContents$SmartcutsMacros.textGet, $$Array.append(contentsInParagraphUntilTextNode, [List.nth(textContents, index)])).join("");
  if (textInParagraphUpToAndIncludingTextNode.length === offsetSinceParagraphStarts) {
    return [{
              TAG: /* CursorAtEndOfNthParagraph */1,
              _0: nthParagraph
            }];
  }
  var wordsSinceParagraphStarts = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, textInParagraphUpToAndIncludingTextNode);
  var arg = Util$SmartcutsMacros.shortcutWithIndex2(wordsSinceParagraphStarts, (function (param, wordIndex) {
          var wordStartOffset = param[0];
          var wordEndOffset = wordStartOffset + param[1].length | 0;
          if (wordEndOffset < offsetSinceParagraphStarts) {
            return ;
          }
          if (wordEndOffset === offsetSinceParagraphStarts) {
            return [{
                      TAG: /* CursorAfterWordAtIndexInNthParagraph */2,
                      _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: 0
                      }
                    }];
          }
          if (wordStartOffset === offsetSinceParagraphStarts) {
            return [{
                      TAG: /* CursorBeforeWordAtIndexInNthParagraph */3,
                      _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: 0
                      }
                    }];
          }
          if (wordStartOffset <= offsetSinceParagraphStarts) {
            return [
                    {
                      TAG: /* CursorInsideWordInNthParagraph */5,
                      _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex
                      }
                    },
                    {
                      TAG: /* CursorInsideWordAtIndexInNthParagraph */4,
                      _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: offsetSinceParagraphStarts - wordStartOffset | 0
                      }
                    }
                  ];
          }
          if (wordIndex === 0) {
            return [{
                      TAG: /* CursorBeforeWordAtIndexInNthParagraph */3,
                      _0: {
                        nthParagraph: nthParagraph,
                        wordIndex: wordIndex,
                        offset: wordStartOffset - offsetSinceParagraphStarts | 0
                      }
                    }];
          }
          var match = Caml_array.get(wordsSinceParagraphStarts, wordIndex - 1 | 0);
          var offsetAfterLastWord = offsetSinceParagraphStarts - (match[0] + match[1].length | 0) | 0;
          return [{
                    TAG: /* CursorAfterWordAtIndexInNthParagraph */2,
                    _0: {
                      nthParagraph: nthParagraph,
                      wordIndex: wordIndex - 1 | 0,
                      offset: offsetAfterLastWord
                    }
                  }];
        }));
  var param = "Expected cursorPosition, " + (String(offsetSinceParagraphStarts) + (", to fall within bounds of value " + StringUtils$SmartcutsMacros.quote($$Array.map(TextContents$SmartcutsMacros.textGet, $$Array.append(contentsInParagraphUntilTextNode, [List.nth(textContents, index)])).join(""))));
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

function stringify(_semantics) {
  return "TODO";
}

var $$Text;

exports.$$Text = $$Text;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.ofContentEditableCursor = ofContentEditableCursor;
exports.stringify = stringify;
/* ord Not a pure module */
